import React, { FC } from "react";
import type { AutomationPerpetualKycProps, ParsedContentNode } from "@/types";
import { ContentManager } from "../content-manager";
import { TextCols } from "../text-cols";

export const AutomationPerpetualKyc: FC<AutomationPerpetualKycProps> = ({
  content,
  cards,
  cta,
}) => {
  const subtitle: ParsedContentNode[] = [{
    type: 'paragraph',
    html: '<p>For the first time</p<'
  }]
  return (
    <section className="automationPerpetualKyc">
      <div className="automationPerpetualKyc--inner">
        <div className="wrapper">
            <TextCols content={content} maxTitleWidth={766} />
        </div>
        <div className="wrapper wrapper_lg">
          <div className="automationPerpetualKyc--cards">
            {cards?.map((card, index) => {
              return (
                <div
                  key={index}
                  className="automationPerpetualKyc--card"
                  onMouseEnter={(event) => {
                    const target = event.currentTarget as HTMLElement;
                    target.classList.add("hover-animation-bounce");
                  }}
                  onAnimationEnd={(event) => {
                    const target = event.target as HTMLElement;
                    target.classList.remove("hover-animation-bounce");
                  }}
                >
                  <ContentManager 
                    className="automationPerpetualKyc--card-subtitle"
                    content={subtitle}
                  />
                  {card.title && (
                    <ContentManager
                      className="automationPerpetualKyc--card-title"
                      content={card.title}
                    />
                  )}
                  {card.description && (
                    <ContentManager
                      content={card.description}
                      className="automationPerpetualKyc--card-description"              
                    />
                  )}
                </div>
              );
            })}
          </div>
          {/* TODO: Temporary hidden */}
          {/* <Cta
            cta={cta}
            theme="light"
            className="automationPerpetualKyc--cta"
          /> */}
        </div>
      </div>
    </section>
  );
};
